module.exports = " .alf{\r\n    width: 75%;\r\n }\r\n\r\n .checkbox-size{\r\n   height: 20px;\r\n   width: 20px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modaladminusuarioscts/modaladminusuarioscts.component.css
// module id = ./src/app/modaladminusuarioscts/modaladminusuarioscts.component.css
// module chunks = main